import gameiomModel from "gameiom/model/gameiom-model";
import Gameplay from "slotworks/model/gameplay/gameplay";
import PickRequestPayload from "slotworks/model/gameplay/requests/pick-request-payload";
import { RequestBuilder } from "slotworks/server/builders/request-builder";
import { SocketRequest } from "slotworks/server/connectors/socket-connector";

export class PickRequestBuilder implements RequestBuilder {

    public static force: string;

    public filter(request: any): boolean {
        return request instanceof PickRequestPayload;
    }
    public build(gameplay: Gameplay, request: PickRequestPayload) {

        const force: string | number[] = PickRequestBuilder.force;

        const body = {
            publicState: {
                action: "pick",
                index: request.pick,
                gameId: gameiomModel.gameId,
                force
            }
        };

        if (body.publicState.force === null) {
            delete body.publicState.force;
        }

        PickRequestBuilder.force = null;

        return new SocketRequest(body, gameiomModel.url);
    }
}

export default new PickRequestBuilder();
